var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_001-calculator",
    "data-name": "001-calculator",
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.214,
    height: 69.126,
    viewBox: "0 0 52.214 69.126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_172",
    "data-name": "Grupo 172",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_582",
    "data-name": "Caminho 582",
    d: "M109.741,0H67.733a5.109,5.109,0,0,0-5.1,5.1V50.2a1.013,1.013,0,1,0,2.025,0V5.1a3.082,3.082,0,0,1,3.078-3.078h42.007A3.082,3.082,0,0,1,112.819,5.1v8.2a1.013,1.013,0,1,0,2.025,0V5.1a5.109,5.109,0,0,0-5.1-5.1Z",
    transform: "translate(-62.63 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_583",
    "data-name": "Caminho 583",
    d: "M113.832,126a1.013,1.013,0,0,0-1.013,1.013v46a3.082,3.082,0,0,1-3.078,3.078H67.733a3.082,3.082,0,0,1-3.078-3.078v-9.1a1.013,1.013,0,1,0-2.025,0v9.1a5.109,5.109,0,0,0,5.1,5.1h42.007a5.109,5.109,0,0,0,5.1-5.1v-46A1.013,1.013,0,0,0,113.832,126Z",
    transform: "translate(-62.63 -108.989)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_584",
    "data-name": "Caminho 584",
    d: "M134.7,32.33h-36a3.744,3.744,0,0,0-3.74,3.74v5.454a3.745,3.745,0,0,0,3.74,3.741h3.2a1.013,1.013,0,0,0,0-2.025H98.7a1.717,1.717,0,0,1-1.715-1.716V36.07A1.717,1.717,0,0,1,98.7,34.355h36a1.717,1.717,0,0,1,1.715,1.715v5.454A1.717,1.717,0,0,1,134.7,43.24H106.629a1.013,1.013,0,1,0,0,2.025H134.7a3.745,3.745,0,0,0,3.74-3.741V36.07A3.744,3.744,0,0,0,134.7,32.33Z",
    transform: "translate(-90.595 -27.965)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_585",
    "data-name": "Caminho 585",
    d: "M360.38,160.618a1.013,1.013,0,0,0-1.013-1.013h-6.819a1.013,1.013,0,0,0-1.013,1.013v6.819a1.013,1.013,0,0,0,1.013,1.013h6.819a1.013,1.013,0,0,0,1.013-1.013Zm-2.025,5.807h-4.794V161.63h4.794Z",
    transform: "translate(-312.53 -138.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_586",
    "data-name": "Caminho 586",
    d: "M275.526,160.618a1.013,1.013,0,0,0-1.013-1.013h-6.819a1.013,1.013,0,0,0-1.013,1.013v6.819a1.013,1.013,0,0,0,1.013,1.013h6.819a1.013,1.013,0,0,0,1.013-1.013Zm-2.025,5.807h-4.794V161.63H273.5Z",
    transform: "translate(-239.133 -138.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_587",
    "data-name": "Caminho 587",
    d: "M94.955,167.438a1.013,1.013,0,0,0,1.013,1.013h6.819a1.013,1.013,0,0,0,1.013-1.013v-6.819a1.013,1.013,0,0,0-1.013-1.013H95.968a1.013,1.013,0,0,0-1.013,1.013Zm2.025-5.807h4.794v4.794H96.98Z",
    transform: "translate(-90.591 -138.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_588",
    "data-name": "Caminho 588",
    d: "M188.653,160.618a1.013,1.013,0,0,0-1.013-1.013h-6.819a1.013,1.013,0,0,0-1.013,1.013v6.819a1.013,1.013,0,0,0,1.013,1.013h6.819a1.013,1.013,0,0,0,1.013-1.013Zm-2.025,5.807h-4.794V161.63h4.794Z",
    transform: "translate(-163.988 -138.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_589",
    "data-name": "Caminho 589",
    d: "M360.38,245.472a1.013,1.013,0,0,0-1.013-1.013h-6.819a1.013,1.013,0,0,0-1.013,1.013v6.819a1.013,1.013,0,0,0,1.013,1.013h6.819a1.013,1.013,0,0,0,1.013-1.013Zm-2.025,5.807h-4.794v-4.794h4.794Z",
    transform: "translate(-312.53 -211.454)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_590",
    "data-name": "Caminho 590",
    d: "M275.526,245.472a1.013,1.013,0,0,0-1.013-1.013h-6.819a1.013,1.013,0,0,0-1.013,1.013v6.819a1.013,1.013,0,0,0,1.013,1.013h6.819a1.013,1.013,0,0,0,1.013-1.013Zm-2.025,5.807h-4.794v-4.794H273.5Z",
    transform: "translate(-239.133 -211.454)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_591",
    "data-name": "Caminho 591",
    d: "M94.955,252.291a1.013,1.013,0,0,0,1.013,1.013h6.819a1.013,1.013,0,0,0,1.013-1.013v-6.819a1.013,1.013,0,0,0-1.013-1.013H95.968a1.013,1.013,0,0,0-1.013,1.013Zm2.025-5.807h4.794v4.794H96.98Z",
    transform: "translate(-90.591 -211.454)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_592",
    "data-name": "Caminho 592",
    d: "M188.653,245.472a1.013,1.013,0,0,0-1.013-1.013h-6.819a1.013,1.013,0,0,0-1.013,1.013v6.819a1.013,1.013,0,0,0,1.013,1.013h6.819a1.013,1.013,0,0,0,1.013-1.013Zm-2.025,5.807h-4.794v-4.794h4.794Z",
    transform: "translate(-163.988 -211.454)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_593",
    "data-name": "Caminho 593",
    d: "M275.526,330.326a1.013,1.013,0,0,0-1.013-1.013h-6.819a1.013,1.013,0,0,0-1.013,1.013v6.819a1.013,1.013,0,0,0,1.013,1.013h6.819a1.013,1.013,0,0,0,1.013-1.013Zm-2.025,5.807h-4.794v-4.794H273.5Z",
    transform: "translate(-239.133 -284.852)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_594",
    "data-name": "Caminho 594",
    d: "M94.955,337.145a1.013,1.013,0,0,0,1.013,1.013h6.819a1.013,1.013,0,0,0,1.013-1.013v-6.819a1.013,1.013,0,0,0-1.013-1.013H95.968a1.013,1.013,0,0,0-1.013,1.013Zm2.025-5.807h4.794v4.794H96.98Z",
    transform: "translate(-90.591 -284.852)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_595",
    "data-name": "Caminho 595",
    d: "M188.653,330.326a1.013,1.013,0,0,0-1.013-1.013h-6.819a1.013,1.013,0,0,0-1.013,1.013v6.819a1.013,1.013,0,0,0,1.013,1.013h6.819a1.013,1.013,0,0,0,1.013-1.013Zm-2.025,5.807h-4.794v-4.794h4.794Z",
    transform: "translate(-163.988 -284.852)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_596",
    "data-name": "Caminho 596",
    d: "M359.368,329.313h-6.819a1.013,1.013,0,0,0-1.013,1.013V348.6a1.013,1.013,0,0,0,1.013,1.013h6.819a1.013,1.013,0,0,0,1.013-1.013V330.326A1.013,1.013,0,0,0,359.368,329.313Zm-1.013,18.275h-4.794v-16.25h4.794Z",
    transform: "translate(-312.53 -284.852)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_597",
    "data-name": "Caminho 597",
    d: "M274.514,414.167h-6.819a1.013,1.013,0,0,0-1.013,1.013V422a1.013,1.013,0,0,0,1.013,1.013h6.819A1.013,1.013,0,0,0,275.526,422V415.18A1.012,1.012,0,0,0,274.514,414.167Zm-1.013,6.819h-4.794v-4.794H273.5Z",
    transform: "translate(-239.133 -358.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_598",
    "data-name": "Caminho 598",
    d: "M94.955,422a1.013,1.013,0,0,0,1.013,1.013h6.819A1.013,1.013,0,0,0,103.8,422V415.18a1.013,1.013,0,0,0-1.013-1.013H95.968a1.013,1.013,0,0,0-1.013,1.013Zm2.025-5.807h4.794v4.794H96.98Z",
    transform: "translate(-90.591 -358.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_599",
    "data-name": "Caminho 599",
    d: "M187.641,414.167h-6.819a1.013,1.013,0,0,0-1.013,1.013V422a1.013,1.013,0,0,0,1.013,1.013h6.819A1.013,1.013,0,0,0,188.653,422V415.18A1.013,1.013,0,0,0,187.641,414.167Zm-1.013,6.819h-4.794v-4.794h4.794Z",
    transform: "translate(-163.988 -358.25)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.1f7b62726fe52d6511f8254d5c0ef7ee.svg";
export { ForwardRef as ReactComponent };